import { createFileRoute } from '@tanstack/react-router';

import { RevenueLanding } from '@apps/web/components/admin/revenue/revenue_landing';

export const Route = createFileRoute('/_app/admin/revenue/accounts')({
    head: () => ({ meta: [{ title: 'Revenue Accounts | Phoebe Admin' }] }),
    component: RevenueLanding,
});
